import { render } from "./IconDescription.vue?vue&type=template&id=78d14ecf"
import script from "./IconDescription.vue?vue&type=script&lang=js"
export * from "./IconDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__